import type { Dispatch } from 'react';

export function wrapActionWithDispatch<D, Args extends unknown[], R extends D>(
  dispatch: Dispatch<D>,
  action: (...args: Args) => R,
) {
  return (...args: Args) => dispatch(action(...args));
}
